export default __webpack_public_path__ + "static/KB-PopUp-b3b0eec2cc972edce37275f071ad0d9a.png";